import { render, staticRenderFns } from "./namihira_story.vue?vue&type=template&id=4729c16d&scoped=true&"
import script from "./namihira_story.vue?vue&type=script&lang=js&"
export * from "./namihira_story.vue?vue&type=script&lang=js&"
import style0 from "./namihira_story.vue?vue&type=style&index=0&id=4729c16d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4729c16d",
  null
  
)

export default component.exports